var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Meeting',{attrs:{"meetId":_vm.$route.params.meetId,"username":_vm.username},on:{"~endMeet":function($event){return _vm.endMeet($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }